export const resources = {
  BrandsModel: '',
  UploadSelectBrandsAllBrands: '',
  UploadServiceDefaultName: '',
  ManageBrandCategories: '',
  SettingsLoading: '',
  CheckboxSelectLabel: ''
};
